const ExcludedSubjectTotals = ({ form }: { form: any }) => {
    const subtotal = form.subtotal || 0;
    const incomeTaxWithholding = form.incomeTaxWithholding || 0;
    const total = form.total || 0;
  
    return (
      <div className="w-full max-w-md space-y-4 text-sm uppercase">
        <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </p>
        <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
          <span>Retención Renta</span>
          <span>${incomeTaxWithholding.toFixed(2)}</span>
        </p>
        <p className="flex justify-between border-t pt-4 font-semibold text-gray-900 dark:text-white dark:border-strokedark">
          <span>Total a Pagar</span>
          <span>${total.toFixed(2)}</span>
        </p>
      </div>
    );
  };
  
  export default ExcludedSubjectTotals;
  